import { Group, SegmentedControl, Tabs } from "@mantine/core";
import React from "react";
import { useHistory } from "react-router";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import ChecklistPicker from "./ChecklistPicker";
import { ChecklistTableVariant, setActiveChecklistTabInRedux, setChecklistTableVariantInRedux } from "./checklistSlice";
import {
  selectChecklistActiveTab,
  selectActiveChecklist,
  selectChecklistTableVariant,
  selectCanSwitchChecklistTableVariant,
} from "./checklistSelectors";
import { IChecklistPopulated } from "@mctypes/checklist.types";

const ChecklistTabs: React.FC<{ checklist?: IChecklistPopulated | null }> = ({ checklist: checklistProp }) => {
  const dispatch = useAppDispatch();
  const { checklistId } = useParams<{ checklistId: string }>();
  const activeTab = useAppSelector(selectChecklistActiveTab);
  const selectedChecklist = useAppSelector((state) => selectActiveChecklist(state, checklistId));
  const checklistTableVariant = useAppSelector(selectChecklistTableVariant);
  const checklist = checklistProp ?? selectedChecklist;
  const canSwitchChecklistTableVariant = useAppSelector(selectCanSwitchChecklistTableVariant);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);

  const urlHasDoksamEqualsTrue = params.get("doksam") === "true";

  return (
    <Group
      justify="space-between"
      align="end"
      pt="xs"
      mx="xs"
      wrap="nowrap"
      style={{ boxShadow: "inset 0 -2px 0 0 #e4e7eb" }}
    >
      <Tabs
        value={activeTab}
        onChange={(value) => dispatch(setActiveChecklistTabInRedux((value ?? "CHECKLIST") as any))}
        styles={{ tab: { fontWeight: 600 } }}
      >
        <Tabs.List>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="CHECKLIST">
            {checklist?.isTemplate === true ? "Sjekklistemal" : "Sjekkliste"}
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="LOGS">
            Logg
          </Tabs.Tab>
          <Tabs.Tab style={{ fontSize: "1.05em", fontWeight: 400 }} value="SETTINGS">
            Innstillinger
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Group gap="sm" wrap="nowrap" pb="xs">
        {canSwitchChecklistTableVariant && (
          <SegmentedControl
            size="xs"
            color="mc-primary"
            value={checklistTableVariant}
            onChange={(value) => dispatch(setChecklistTableVariantInRedux(value as ChecklistTableVariant))}
            data={[
              { value: "legacy", label: "Gammel side" },
              { value: "refactored", label: "Ny side" },
            ]}
          />
        )}
        {urlHasDoksamEqualsTrue === false && <ChecklistPicker checklist={checklist} />}
      </Group>
    </Group>
  );
};

export default ChecklistTabs;
